import React from "react"

function Title(props) {
    return(
        <div className="title">

            <h1>Tutankhamun</h1>

        </div>
    )
    
}

export default Title